import React, { ReactNode, useState } from 'react';
import Spinner from 'components/spinner';

import { getSessionId, setSessionId, setRedirectUrl } from 'utils/sessionStorage';
import { redirectToAuthService } from 'utils/redirectToAuthService';

interface IWithAuth {
  children: ReactNode;
}

const _: any = (target: any) => target.location.protocol + '//' + target.location.hostname;

export default function WithAuth({ children }: IWithAuth) {
  const [sessionId, set_sessionId] = useState<string>(getSessionId());
  const [dataIsComing] = useState<boolean>(!!new URLSearchParams(window.location.search).get('more_data'));

  const parseMoreData = (message: any) => {
    if (message.origin !== _(window) || typeof message.data !== 'string') {
      return;
    }
    if (message?.data?.indexOf('sessionId:') !== -1) {
      const id: string = message.data.replace('sessionId:', '');
      if (id !== 'empty') {
        setSessionId(message.data.replace('sessionId:', ''));
        set_sessionId(message.data.replace('sessionId:', ''));
        window.opener?.postMessage('received', message.origin);
        window.removeEventListener('message', parseMoreData);
      } else {
        console.log('received empty session id');
      }
    }
  };

  window.removeEventListener('message', parseMoreData);
  window.addEventListener('message', parseMoreData);

  if (!sessionId && !dataIsComing) {
    console.log('Needs authentication…');
    setRedirectUrl(window.location.pathname);
    redirectToAuthService();
    return <Spinner />;
  } else if (!sessionId && dataIsComing && window.self !== window.opener && window.opener) {
    console.log('Loaded, waiting data…');
    window.opener?.postMessage('loaded', _(window));
    return <Spinner />;
  } else if (sessionId) {
    console.log('Received data…');
    window.history.replaceState({}, '', window.location.href.split('?')[0]);
    return <>{children}</>;
  } else {
    console.error('Unidentified error');
    return <Spinner />;
  }
}
